export enum PersonType {
  legalPerson = 'lp',
  naturalPerson = 'np'
}
